module.exports = __webpack_public_path__ + "img/1F493.ba7bb61a.svg";